import { apiClient } from '@indipia/shared';
import { SHARE_LOAD_TIMEOUT_MS } from '@indipia/shared-features';
import type { ApiResponse } from '@indipia/shared-types';
import type { OrderShareData, ReplyPayload, ReplyResponse } from '../pages/share/vendorOrderReply.logic';
import { listEntryParams } from './orderListShareApi';

// C-3-1 거래처 발주 회신 — 외부 링크(공유 쿠키 share_jwt) 전용 API. shareId 는 경로·본문·쿼리에 싣지 않는다(F-04 §9).
// 받은 발주 목록에서 들어온 화면이면 쿼리 orderVendorId 를 모든 호출에 붙인다(listEntryParams, E-15·E-12).
// 쓰기 호출은 자동 재시도하지 않는다(응답 없음 처리는 화면에서 B1 재조회로 결과 확인).
const BASE = '/schedule/order-shares/me';

/** B1 발주 조회·회신 가능 여부 (R2). 응답 형태 검증은 화면(inspectOrderShare)이 한다. */
export async function fetchOrderShare(signal?: AbortSignal): Promise<OrderShareData> {
  const res = await apiClient.get<ApiResponse<OrderShareData>>(BASE, { params: listEntryParams(), signal, timeout: SHARE_LOAD_TIMEOUT_MS });
  return res.data.data;
}

/** B2 회신 제출 (W1, 200) */
export async function postOrderReply(payload: ReplyPayload): Promise<ReplyResponse> {
  const res = await apiClient.post<ApiResponse<ReplyResponse>>(`${BASE}/replies`, payload, { params: listEntryParams() });
  return res.data.data;
}

/**
 * 받은 발주 목록 링크 발급 (E-12 R20, 건별 토큰으로 호출). 같은 거래처·사업장의 목록 링크 URL 을 돌려받는다.
 * 쿠키에는 토큰 하나만 담기므로 화면 이동은 이 URL 로 전체 이동한다. 응답에 url 문자열이 없으면 throw(값을 만들지 않음).
 */
export async function issueOrderListLink(): Promise<string> {
  const res = await apiClient.post<ApiResponse<{ url?: string }>>(`${BASE}/list-link`);
  const url = res.data.data?.url;
  if (typeof url !== 'string' || !/^(https?:\/\/|\/)/.test(url)) throw new Error('list-link url missing');
  return url;
}
